export class LocalData<T> {
  data: T;
  expiresOn: Date;
}
